import Connection from './connection'
import PaginatedStore from './paginated_store'

export default class Searches extends PaginatedStore {
  constructor(scope) {
    super(new Connection('searches', scope))
  }
}



// WEBPACK FOOTER //
// client/stores/searches.js